import { render, staticRenderFns } from "./Initiativbewerbung.vue?vue&type=template&id=1bfaa742&"
import script from "./Initiativbewerbung.vue?vue&type=script&lang=js&"
export * from "./Initiativbewerbung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports